import "../styles/FooterContainer.scss";

function FooterContainer({ children }: any) {
    return <footer className="footer-container">{children}</footer>;
}

export default FooterContainer;
